export default __webpack_public_path__ + "static/media/EmptyCart.53b77079.svg";